// extracted by mini-css-extract-plugin
export var alertIcon = "_ne-0";